import { IDiagram } from 'store/ticket-service/types';

import { DiagramTypes } from 'core/enums/common';

export const orderDiagrams = (diagrams: Array<IDiagram>): Array<IDiagram> => {
	return [...diagrams].sort(
		(a, b) =>
			Object.keys(DiagramTypes).indexOf(a.title) - Object.keys(DiagramTypes).indexOf(b.title)
	);
};
